import React from 'react';
import type { CheckboxSelectEntry } from '@atlassian/jira-filters/src/common/types.tsx';
import ListFilter from '@atlassian/jira-filters/src/common/ui/list/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type { ProjectId, VersionId } from '@atlassian/jira-shared-types/src/general.tsx';
import { useFixVersions } from '../../../services/get-versions';
import messages from './messages';

type Props = {
	projectId: ProjectId;
	isNested?: boolean;
	selectedValues: string[];
	onChange: (arg: VersionId[]) => void;
};

const VersionFilter = ({ projectId, isNested, selectedValues, onChange }: Props) => {
	const { data, error, loading } = useFixVersions(projectId);

	if (error) {
		throw error;
	}

	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fixVersions = data
		? data.map((version) => ({
				value: version.name,
				label: version.name,
			}))
		: [];

	return (
		<ListFilter
			label={formatMessage(messages.versions)}
			values={fixVersions}
			selectedValues={selectedValues}
			onChange={(newSelectedFixVersions: CheckboxSelectEntry[]) => {
				fireUIAnalytics(
					createAnalyticsEvent({
						action: 'toggled',
						actionSubject: 'deploymentsFixVersionsFilter',
					}),
				);
				onChange(newSelectedFixVersions.map((v) => v.value));
			}}
			isLoading={loading}
			showMenuIfValuesAreEmpty={false}
			isNested={isNested}
		/>
	);
};

export default VersionFilter;
